export default {
  SET_TOKEN(state, token) {
    localStorage.setItem('token_key', token)
    state.token = token
  },
  REMOVE_TOKEN(state) {
    localStorage.removeItem('token_key')
    state.token = null
  },
  SET_LANGUAGE(state, language) {
    state.language = language
  },
  SET_CITY_LIST(state, data) {
    state.cityList = data
  },
  SET_ADVERTS_LIST(state, data) {
    state.advertsList = data
  },
  SET_ADVERTS_FOUND_FILTER_COUNT(state, data) {
    state.countAdverts = data
  },
  SET_USER_ADVERTS_LIST(state, data) {
    state.userAdverts = data
  },
  SET_USER_COMPANY(state, data) {
    state.userCompany = data
  },
  SET_NEW_PROPERTY_LIST(state, data) {
    state.newPropertyList = data
  },
  SET_SKIP_ADVERTS(state, data) {
    state.skipAdverts = data
  },
  SET_USER_INFO(state, data) {
    state.userInfo = {
      role: data.role,
      phone: data.phone
    }
  },
  SET_DINAMIC_FILTERS(state, data) {
    state.dynamicFilters = data
  },
  SET_RANGE_FILTERS(state, data) {
    state.rangeFilters = data
  },
  SET_CURRENCY_LIST(state, data) {
    state.currencyList = data
  },
  SET_ADVERTS_ITEMS(state, data) {
    state.advertItems = data
  },
  SET_DISTRICT_LIST(state, data) {
    const filters = JSON.parse(localStorage.filters)
    const list = data
    list.unshift({
      id: null,
      text: filters.items.CityId === 1 ? 'Все районы' : 'Все города'
    })
    state.districtList = list
  },
  SET_ADVERT_ITEM(state, data) {
    state.advertItem = data
  },
  SET_ADVERT_EDIT_ITEM(state, data) {
    state.editAdvert = data
  },
  GET_ADVERT_LIST_LOADING(state, payload) {
    state.loading.getAdvertsList = payload
  },
  SET_COORDINATION(state, payload) {
    state.coordinates = payload
  },
  SET_VIEW_TYPE(state, payload) {
    state.viewType = payload
  },
  SET_MARKER_COORDS(state, payload) {
    state.markerCoords.latitude = payload.lat
    state.markerCoords.longitude = payload.lng
  }
}
